module.exports = __webpack_public_path__ + "img/logo_bg.1def38b.svg";